const BrowserLocation = (function () {
  function uriParams() {
    const queryString = {},
          query = window.location.search.substring(1),
          parmsArray = query.split('&');

    if (parmsArray.length <= 0) {
      return queryString;
    }

    for (let i = 0; i < parmsArray.length; i++) {
      const pair = parmsArray[i].split('='),
            value = decodeURIComponent(pair[1]);

      if (value !== '' && pair[0] !== '') {
        queryString[pair[0]] = value;
      }
    }
    return queryString;
  }

  return {
    uriParams
  };
}());

export default BrowserLocation;



// WEBPACK FOOTER //
// ./browserLocation.js